{
    "testingText": {
        "test": "This is a Test",
        "Hello": "Hello",
        "Array": [
            "This is the first item",
            "This is the second item",
            "This is the third item"
        ]
    },
    "layerUnits": {
        "inch": "inch",
        "inches": "inches",
        "feet": "feet",
        "sqft": "sqft",
        "acres": "acres",
        "meters": "meters",
        "miles": "miles",
        "sqmi": "square miles",
        "count": "count",
        "in": "inches",
        "percent": "%",
        "%": "%",
        "dollars": "dollars",
        "gal": "gallons",
        "tons": "tons",
        "percentile": "percentile",
        "years": "years",
        "coordinate": "coordinate",
        "F": "°F",
        "fahrenheit": "°F",
        "in/hr": "in/hr"
    },
    "roles": {
        "workshopAdmin": "Admin",
        "editor": "Editor",
        "contributor": "Contributor",
        "viewer": "Viewer",
        "guest": "Guest",
        "workshopAdminTooltip": "You can create and edit sites, add remedies and leave comments. You can also invite and remove collaborators and manage their roles.",
        "editorTooltip": "You can create and edit sites, add remedies and leave comments. You can also invite collaborators.",
        "contributorTooltip": "You can add remedies and leave comments.",
        "viewerTooltip": "You can view sites and react to remedies."
    },
    "drawEvents": {
        "start": "Click to add points and draw your site.",
        "sketchReadyToClose": "Click either endpoint at any time to complete the shape and create your site.",
        "edit": "Edit your site by adding, deleting, and moving points.",
        "resize": "Click and drag any point to scale your site.",
        "editFootprint": "Edit your remedy footprint by adding, deleting, and moving points.",
        "rotateFootprint": "Click and drag to rotate your footprint.",
        "resizeFootprint": "Click and drag any point to scale your footprint."
    },
    "opportunityRanks": {
        "Very High": "Very High",
        "High": "High",
        "Moderate": "Moderate",
        "Low": "Low",
        "Very Low": "Very Low",
        "Unknown": "Unknown",
        "Very HighOpportunity": "Very High Opportunities",
        "HighOpportunity": "High Opportunities",
        "ModerateOpportunity": "Moderate Opportunities",
        "LowOpportunity": "Low Opportunities",
        "Very LowOpportunity": "Very Low Opportunities",
        "UnknownOpportunity": "No Data Available"
    },
    "referenceContentType": {
        "remedy": "remedies",
        "effect": "benefits",
        "dataLayer": "data layers"
    },
    "UITabs": {
        "benefitsCosts": "Benefits & Costs",
        "pairings": "Pairings",
        "tipsResources": "Tips & Resources",
        "remedies": "Remedies",
        "dataLayers": "Data Layers",
        "documentation": "Documentation",
        "tips": "Tips",
        "benefits": "Benefits",
        "conditions": "Conditions",
        "details": "Details",
        "sites": "Sites",
        "layers": "Layers",
        "summary": "Summary"
    },
    "footprintPlacements": {
        "aboveground": "above ground",
        "belowground": "below ground",
        "canopy": "canopy",
        "ground": "ground"
    }
}